export enum KEYS {
  /** user_info */
  USER_INFO = 'user_info',
  /** user_msg */
  USER_MSG = 'user_msg'
}
